export enum BannerSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
